<button mat-menu-item (click)="emitAction()"
        [disabled]="disabled">{{ name | translate }}
</button>
@if (hasDivider) {
  <mat-divider></mat-divider>
}
